// 全局配置：后端接口地址（环境变量见 .env 文件）
export default {
    baseUrl: process.env.VUE_APP_BASE_API,
};
